import { rootErrorHandlers } from '@reinz/telemetry/createTelemetry'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { initGA } from './lib/analytics'
import { telemetry } from './lib/telemetry'

// Before render, so gtag.js is in flight while React boots and is ready before the
// signed-in user is identified.
initGA()

createRoot(document.getElementById('root')!, rootErrorHandlers(telemetry)).render(<App />)
